import { useState, useRef, useCallback } from 'react';
import { parseSSEEvents, mergeToolBlocks } from '../MessageBlockRenderer';
import { convertHistory } from './converters';

export function useChatStreamBlocks() {
    const [blocks, setBlocks] = useState([]);
    const [isStreaming, setIsStreaming] = useState(false);
    const baseRef = useRef([]);
    const blocksRef = useRef([]);

    const loadHistory = useCallback((historyMessages) => {
        const historyBlocks = convertHistory(historyMessages || []);
        baseRef.current = historyBlocks;
        blocksRef.current = historyBlocks;
        setBlocks(historyBlocks);
    }, []);

    const appendBlock = useCallback((block) => {
        blocksRef.current = [...blocksRef.current, block];
        baseRef.current = blocksRef.current;
        setBlocks(blocksRef.current);
    }, []);

    const appendStreamBlocks = useCallback((rawEvents) => {
        const { blocks: streamBlocks } = parseSSEEvents(rawEvents);
        const merged = mergeToolBlocks([...baseRef.current, ...streamBlocks]);
        blocksRef.current = merged;
        setBlocks(merged);
    }, []);

    const startStreaming = useCallback(() => {
        baseRef.current = blocksRef.current;
        setIsStreaming(true);
    }, []);

    const commitStreamToHistory = useCallback(() => {}, []);

    const stopStreaming = useCallback(() => {
        setIsStreaming(false);
    }, []);

    const reset = useCallback(() => {
        baseRef.current = [];
        blocksRef.current = [];
        setBlocks([]);
        setIsStreaming(false);
    }, []);

    return {
        blocks,
        isStreaming,
        loadHistory,
        appendBlock,
        appendStreamBlocks,
        startStreaming,
        stopStreaming,
        reset,
        commitStreamToHistory,
    };
}
